export default "__VITE_ASSET__BLs0tBlN__"